// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addMonths as fn } from "../addMonths.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addMonthsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addMonthsWithOptions;
